export const instrumentTexts = {
  et: {
    error: "Viga instrumentide laadimisel",
    title: "Rendipillide saadavus",
    pricetext: "Renditasu grupp",
    pricetext1: "Renditasu sõltub perioodi pikkusest - mida kauem rendid, seda soodsam on hind.",
    pricetext2: "Igakuine hind kuvatakse peale soovitud rendiperioodi valikut broneerimisel (nupp allpool).",
    predicted: "Eeldatav saadavus: ",
    headings: {
      a: "Mudeli andmed",
      b: "Spetsiifilised andmed",
      c: "Täiendav info",
      d: "Lepingu andmed",
    },

    color: "Värv",
    keys: "Klahvid",
    basses: "Bassid",
    cassotto: "Kõlakamber",
    reeds: "Kooriplokid (Parem/Vasak)",
    registers: "Registrid (Parem/Vasak)",
    dimensions: "Mõõdud",
    newprice: "Hind uuena",
    usedprice: "Hind kasutatuna",

    colors: {
      Red: "Punane",
      DarkRed: "Tumepunane",
      Black: "Must",
      White: "Valge",
      Blue: "Sinine",
      DarkBlue: "Tumesinine",
      Green: "Roheline",
      DarkGreen: "Tumeroheline",

      Brown: "Pruun",
      LightBrown: "Helepruun",
      Beige: "Beež",

      Silver: "Hõbedane",
      Gold: "Kuldne",
      Grey: "Hall",
      DarkGrey: "Tumehall",

      PearlWhite: "Pärlvalge",
      Ivory: "Elevandiluu",
      Champagne: "Šampanja",

      Turquoise: "Türkiissinine",
      TurquoiseGlitter: "Türkiissinine sädelev",
      GlitterPurple: "Sädelev lilla",
      Purple: "Lilla",
      Burgundy: "Burgundia",

      Sunburst: "Päikeseloojang (Sunburst)",
      WoodFinish: "Puitviimistlus",
      NaturalWood: "Naturaalne puit",

      Custom: "Eritellimus",
      Unknown: "Teadmata",
    },

    action: {
      reserve: "Broneeri",
      loginToReserve: "Logi sisse, et broneerida",
      back: "Tagasi nimekirja",
    },

    status: {
      Available: "Saadaval",
      Reserved: "Broneeritud",
      Rented: "Renditud",
      Unavailable: "Pole saadaval",
      AgreementInProgress: "Leping koostamisel",
      Sold: "Müüdud",
      Created: "Loodud",
      Active: "Aktiivne",
      Test: "Test",
      EndingSoon: "Lõppeb varsti",
      Ended: "Lõppenud",
      Finished: "Lõpetatud"
    },

    labels: {
      brand: "Bränd",
      model: "Mudel",
      keyboard: "Klaviatuuri pikkus",
      keyboardmax: "Klaviatuur koos servadega",
      whitekeywidth: "Valge klahvi laius",
      whitekeys: "Valgeid klahve",
      weight: "Kaal",
      price: "Hind",
      serial: "Seerianumber",
      keys: "Klahvide arv",
      status: "Staatus",
      range: "Ulatus",
      folds: "Lõõtsavolte",
      depth: "Sügavus",
      freebass: "Vababass (klahve)",
      freebassReeds: "Vababassi kooriplokid",
      bassStartNotes: "Bassirea algusnoodid",
    },

    predictedAvailability: (date) =>
      `Eeldatav saadavus: ${date}`,
  },

  en: {
    error: "Error fetching available instruments",
    title: "Rental Instruments Availability",
    pricetext: "Price level",
    pricetext1: "The rental fee depends on the length of the period - the longer the rental, the cheaper the price.",
    pricetext2: "The monthly price is displayed after selecting the period during reservation (button below).",
    predicted: "Predicted availability: ",
    headings: {
      a: "Model Details",
      b: "Specific Details",
      c: "Additional Info",
      d: "Agreement Details",
    },
    color: "Color",
    keys: "Keys",
    basses: "Basses",
    cassotto: "Cassotto",
    reeds: "Reeds (Right/Left)",
    registers: "Registers (Right/Left)",
    dimensions: "Dimensions",
    newprice: "New instrument's price",
    usedprice: "Used instrument's price",

    colors: {
      Red: "Red",
      DarkRed: "Dark red",
      Black: "Black",
      White: "White",
      Blue: "Blue",
      DarkBlue: "Dark blue",
      Green: "Green",
      DarkGreen: "Dark green",

      Brown: "Brown",
      LightBrown: "Light brown",
      Beige: "Beige",

      Silver: "Silver",
      Gold: "Gold",
      Grey: "Grey",
      DarkGrey: "Dark grey",

      PearlWhite: "Pearl white",
      Ivory: "Ivory",
      Champagne: "Champagne",

      Turquoise: "Turquoise",
      TurquoiseGlitter: "Turquoise glitter",
      GlitterPurple: "Glitter purple",
      Purple: "Purple",
      Burgundy: "Burgundy",

      Sunburst: "Sunburst",
      WoodFinish: "Wood finish",
      NaturalWood: "Natural wood",

      Custom: "Custom",
      Unknown: "Unknown",
    },

    action: {
      reserve: "Reserve",
      loginToReserve: "Log in to reserve",
      back: "Back to list",
    },

    status: {
      Available: "Available",
      Reserved: "Reserved",
      Rented: "Rented",
      Unavailable: "Unavailable",
      AgreementInProgress: "Agreement in progress",
      Sold: "Sold",
      Created: "Created",
      Active: "Active",
      Test: "Test",
      EndingSoon: "Ending Soon",
      Ended: "Ended",
      Finished: "Finished"
    },

    labels: {
      brand: "Brand",
      model: "Model",
      keyboard: "Keyboard length",
      keyboardmax: "Keyboard incl. edges",
      whitekeywidth: "White key width",
      whitekeys: "White keys",
      weight: "Weight",
      price: "Price",
      serial: "Serial number",
      keys: "Number of keys",
      status: "Status",
      range: "Range",
      folds: "Bellows folds",
      depth: "Depth",
      freebass: "Free bass (keys)",
      freebassReeds: "Free bass reeds",
      bassStartNotes: "Bass row start notes",
    },

    predictedAvailability: (date) =>
      `Predicted availability: ${date}`,
  },
};